<template>
  <div class="text-left">
    <div class="row">
      <div class="col">
        <button class="btn btn-link" v-on:click="addResponseCategory">
          Add Letter of Indquiry Category
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div
          v-for="cat in availableCategories.slice().sort($orderByCategory)"
          :key="cat.Application_Template_Response_Category_Id"
          class="mt-4"
        >
          <div class="row">
            <div class="col-auto px-0">
              <i
                class="material-icons pointer"
                v-bind:id="
                  cat.Application_Template_Response_Category_Id + 'toggleIcon'
                "
                data-toggle="collapse"
                v-bind:href="
                  '#category' + cat.Application_Template_Response_Category_Id
                "
                role="button"
                aria-expanded="false"
                v-on:click="
                  $updateToggleIcon(
                    '#' +
                      cat.Application_Template_Response_Category_Id +
                      'toggleIcon'
                  )
                "
                >add</i
              >
            </div>
            <div class="col-auto pr-1">
              <h5
                class="pointer btn-link mb-0"
                v-on:click="editResponseCategory(cat)"
              >
                {{ cat.Category }}
              </h5>
            </div>
            <div class="col-auto pl-0 pr-2 text-secondary">
              <h5>({{ cat.Application_Template_Responses.length }})</h5>
            </div>
            <div class="col-auto pl-0">
              <button
                v-bind:id="
                  'summary' + cat.Application_Template_Response_Category_Id
                "
                class="btn text-left px-0 py-0 mb-1"
                style="height:26px;"
                data-toggle="popover"
                data-trigger="focus"
                v-on:click="
                  $focusElement(
                    'summary' + cat.Application_Template_Response_Category_Id
                  )
                "
                data-placement="right"
                v-bind:data-content="cat.Summary"
              >
                <i class="material-icons-outlined pointer">info</i>
              </button>
            </div>
            <div class="col" />
            <div class="col-auto">
              <button
                class="btn btn-sm btn-link"
                v-on:click="
                  addQuestionResponse(
                    cat.Application_Template_Response_Category_Id,
                    cat.Category
                  )
                "
              >
                Add Letter Template
              </button>
            </div>
          </div>
          <div style="height:1px; background-color:gray; width:100%;" />
          <div
            class="container collapse mt-2"
            v-bind:id="
              'category' + cat.Application_Template_Response_Category_Id
            "
          >
            <div
              v-for="(response, index) in cat.Application_Template_Responses"
              :key="response.Application_Template_Response_Id"
              class="row"
              v-bind:class="{ 'light-background': index % 2 === 1 }"
            >
              <div class="col-auto">
                <i
                  class="material-icons d-block pointer mt-1"
                  v-on:click="
                    editQuestionResponse(
                      response,
                      cat.Application_Template_Response_Category_Id,
                      cat.Category
                    )
                  "
                >
                  edit
                </i>
              </div>
              <div class="col">
                <p class="mb-1">
                  <u>{{ response.Question }}</u>
                </p>
                <p
                  style="white-space: pre-wrap;"
                  v-html="$cleanResponse(response.Response)"
                ></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ResponseCategoryModal
      v-bind:ResponseCategory="responseCategoryToEdit"
      v-bind:ApplicationTemplateResponseType="'32'"
      CategoryType="Letter of Inquiry"
      @addedResponseCategory="responseCategoryAdded"
      @editedResponseCategory="responseCategoryEdited"
      @editClosed="responseCategoryModalClosed"
      @archivedCategory="categoryArchived"
    />
    <LetterOfInquiryTemplateModal
      v-bind:Response="responseToEdit"
      v-bind:ResponseCategoryId="responseCategoryId"
      v-bind:ResponseCategoryName="responseCategoryName"
      @addedResponse="responseAdded"
      @editedResponse="responseEdited"
      @editClosed="questionResponseModalClosed"
    />
  </div>
</template>

<script>
import ResponseCategoryModal from "@/modals/ManageTemplates/ResponseCategoryModal";
import LetterOfInquiryTemplateModal from "@/modals/ManageTemplates/LetterOfInquiryTemplateModal";
import $ from "jquery";

export default {
  name: "ManageQuestionResponse",
  components: {
    ResponseCategoryModal,
    LetterOfInquiryTemplateModal
  },
  data() {
    return {
      availableCategories: [],
      responseCategoryToEdit: null,
      responseToEdit: null,
      responseCategoryId: "",
      responseCategoryName: ""
    };
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    this.availableCategories = await this.$getApplicationTemplateResponseCategories(
      32
    );
    $(document).ready(function() {
      $('[data-toggle="popover"]').popover();
    });
    this.$store.commit("updateLoading", false);
  },
  methods: {
    addResponseCategory() {
      $("#responseCategoryModal").modal("show");
    },
    responseCategoryAdded(newResponseCategory) {
      newResponseCategory.Application_Template_Responses = [];
      this.availableCategories.push(newResponseCategory);
      $('[data-toggle="popover"]').popover();
    },
    editResponseCategory(responseCategory) {
      this.responseCategoryToEdit = responseCategory;
      $("#responseCategoryModal").modal("show");
    },
    responseCategoryEdited(editedResponseCategory) {
      var editingIndex = this.availableCategories.findIndex(
        c =>
          c.Application_Template_Response_Category_Id ==
          editedResponseCategory.Application_Template_Response_Category_Id
      );
      this.$set(this.availableCategories, editingIndex, editedResponseCategory);
      this.responseCategoryToEdit = null;
      $('[data-toggle="popover"]').popover();
    },
    responseCategoryModalClosed() {
      this.responseCategoryToEdit = null;
    },
    addQuestionResponse(categoryId, categoryName) {
      this.responseCategoryId = categoryId;
      this.responseCategoryName = categoryName;
      $("#letterTemplateModal").modal("show");
    },
    responseAdded(newResponse) {
      var categoryIndex = this.availableCategories.findIndex(
        c =>
          c.Application_Template_Response_Category_Id == this.responseCategoryId
      );
      this.availableCategories[
        categoryIndex
      ].Application_Template_Responses.push(newResponse);
    },
    editQuestionResponse(response, categoryId, categoryName) {
      this.responseToEdit = response;
      this.responseCategoryId = categoryId;
      this.responseCategoryName = categoryName;
      $("#letterTemplateModal").modal("show");
    },
    responseEdited(editedResponse) {
      var categoryIndex = this.availableCategories.findIndex(
        c =>
          c.Application_Template_Response_Category_Id == this.responseCategoryId
      );
      var editingIndex = this.availableCategories[
        categoryIndex
      ].Application_Template_Responses.findIndex(
        c =>
          c.Application_Template_Response_Id ==
          editedResponse.Application_Template_Response_Id
      );
      var editedCategory = this.availableCategories[categoryIndex];
      editedCategory.Application_Template_Responses[
        editingIndex
      ] = editedResponse;
      this.$set(this.availableCategories, categoryIndex, editedCategory);
      this.editedResponse = null;
    },
    questionResponseModalClosed() {
      this.responseToEdit = null;
    },
    async categoryArchived() {
      this.$store.commit("updateLoading", true);
      this.availableCategories = await this.$getApplicationTemplateResponseCategories(
        32
      );
      this.$store.commit("updateLoading", false);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
